// Pequenos bordados de Natal: laço, estrelinha e raminho. Cores da marca (rosa antigo e bordeaux) com um verde-sálvia só para as folhas.
const SAGE = "168 184 163";
const GOLD = "#C9A66B";

// Laço de tecido em rosa antigo, com pregas e pesponto, como o das peças.
export const Bow = ({ className = "", style, ...rest }) => (
  <svg aria-hidden="true" viewBox="0 0 48 38" className={className} style={style} {...rest} fill="none" strokeLinejoin="round" strokeLinecap="round">
    <path d="M22 22 13 35l8-2.5 3-10Zm4 0 9 13-8-2.5-3-10Z" fill="#E2A4AE" stroke="#A8566A" strokeWidth="1.3" />
    <path d="M24 19C17 5 3 4 4.500 16 6 28 17 25 24 19Z" fill="#EDB6BE" stroke="#A8566A" strokeWidth="1.3" />
    <path d="M24 19C31 5 45 4 43.500 16 42 28 31 25 24 19Z" fill="#EDB6BE" stroke="#A8566A" strokeWidth="1.3" />
    <path d="M20 17C14 10 9 10 8 14M28 17c6-7 11-7 12-3M19 20c-5 3-9 3-11 1M29 20c5 3 9 3 11 1" stroke="#A8566A" strokeOpacity=".55" strokeWidth="1" />
    <rect x="20" y="15" width="8" height="9" rx="3.500" fill="#E2A4AE" stroke="#A8566A" strokeWidth="1.3" />
  </svg>
);

// Estrela de quatro pontas, dourada e discreta.
export const Spark = ({ className = "", style }) => (
  <svg aria-hidden="true" viewBox="0 0 20 20" className={className} style={style}>
    <path d="M10 1.5c.7 4.6 3.9 7.8 8.5 8.5-4.6.7-7.8 3.9-8.5 8.5-.7-4.6-3.9-7.8-8.5-8.5 4.6-.7 7.8-3.9 8.5-8.5Z" fill={GOLD} />
  </svg>
);

// Folha de azevinho (pontas bicudas), apontada para a direita, com nervura e meia folha mais clara.
const LEAF = "M2 15C6 10 8 11 10 6c3 3 5 2 8-2 2 4 5 4 8 2 1 4 4 4 8 3 2 2 4 4 6 6-2 2-4 4-6 6-4-1-7-1-8 3-3-2-6-2-8 2-3-4-5-5-8-2-2-5-4-4-8-9Z";
const Leaf = ({ r, x, y, s = 1, dark = "#5E7A58", light = "#7F9A76" }) => (
  <g transform={`translate(${x} ${y}) rotate(${r}) scale(${s}) translate(-2 -15)`}>
    <path d={LEAF} fill={dark} stroke="#4A6445" strokeWidth=".8" strokeLinejoin="round" />
    <path d="M2 15C6 10 8 11 10 6c3 3 5 2 8-2 2 4 5 4 8 2 1 4 4 4 8 3 2 2 4 4 6 6Z" fill={light} fillOpacity=".7" />
    <path d="M3 15h34" stroke="#42603E" strokeOpacity=".6" strokeWidth=".9" strokeLinecap="round" />
  </g>
);
const Berry = ({ x, y, r = 5 }) => (
  <g>
    <circle cx={x} cy={y} r={r} fill="#C65A6A" stroke="#9C3F51" strokeWidth=".8" />
    <circle cx={x - r * 0.35} cy={y - r * 0.4} r={r * 0.28} fill="#fff" fillOpacity=".7" />
  </g>
);

// Raminho de azevinho com bagas: enfeita o carimbo da agenda.
export const Holly = ({ className = "", style }) => (
  <svg aria-hidden="true" viewBox="0 0 120 84" className={className} style={style} fill="none">
    <Leaf r={-158} x={58} y={34} s={1.05} />
    <Leaf r={-22} x={62} y={32} s={1.1} />
    <Leaf r={-92} x={60} y={30} s={0.85} dark="#648060" light="#86A07C" />
    <Leaf r={38} x={60} y={36} s={0.85} dark="#648060" light="#86A07C" />
    <Berry x={55} y={36} r={5.6} />
    <Berry x={65} y={39} r={5.2} />
    <Berry x={60} y={29} r={5} />
  </svg>
);
